module.exports = __webpack_public_path__ + "static/media/img-iztapalapa-b.48e30221.jpg";